<template>
  <!-- If any of component is not updating, try adding the key attribute as done in image step -->
  <div class="activity-configurator-step-edit-mode">
    <template v-if="question && activityDetails">
      <BooleanStep v-if="question && question.type === 'Boolean'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <InstructionStep v-if="question && question.type === 'SurveyInstruction'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <NumberScaleStep v-if="question && question.type === 'NumberScale'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <IndexStep v-if="question && question.type === 'Index'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp"> </IndexStep>
      <CustomScaleStep v-if="question && question.type === 'CustomScale'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <VASStep v-if="question && question.type === 'VAS'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <NumberStep v-else-if="question && question.type === 'Number'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <TextStep v-else-if="question && question.type === 'Text'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <DateTimeStep v-else-if="question && question.type === 'DateTime'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <MultiChoiceStep v-else-if="question && question.type === 'MultiChoice'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <ImageChoiceStep v-else-if="question && question.type === 'Image'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :key="componentKey" :editorOptionForHelp="editorOptionForHelp" />
      <DropDownStep v-else-if="question && question.type === 'DropDown'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <MeasurementsStep v-else-if="question && question.type === 'Measurements'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <LogStep v-else-if="question && question.type === 'Log'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <ValidatedEntryStep v-else-if="question && question.type === 'ValidatedEntry'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <GPSkinStep v-else-if="question && question.type === 'GPSkin'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" :removeMaxDimensions="true" />
      <ImageCaptureStep v-else-if="question && question.type === 'ImageCapture'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" :restrict-add-help="true" />
      <WongBakerStep v-else-if="question && question.type === 'WongBaker'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" />
      <AudioRecording v-else-if="question && question.type === 'AudioRecording'" ref="activityStepEdit" :question="question" :mode="mode" :audioSkippable="audioSkippable" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" :restrict-add-help="true" />
      <MedicationSelectorStep v-else-if="question && question.type === 'MedicationSelector'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" :restrict-add-help="true" />
      <VideoRecording v-else-if="question && question.type === 'VideoRecording'" ref="activityStepEdit" :question="question" :mode="mode" :videoSkippable="videoSkippable" :activityDetails="activityDetails" :commonProps="commonProps" :editorOptionForHelp="editorOptionForHelp" :restrict-add-help="true" />
      <SurveyCompletion v-else-if="question && question.type === 'SurveyCompletion'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" />
      <SkinAnalyser v-else-if="question && question.type === 'SkinAnalyser'" ref="activityStepEdit" :question="question" :mode="mode" :activityDetails="activityDetails" :commonProps="commonProps" />
    </template>
  </div>
</template>

<script>
// STEPS
import BooleanStep from "@/components/activity-library/activity-steps/boolean";
import InstructionStep from "@/components/activity-library/activity-steps/instruction";
import NumberScaleStep from "@/components/activity-library/activity-steps/number-scale";
import CustomScaleStep from "@/components/activity-library/activity-steps/custom-scale";
import VASStep from "@/components/activity-library/activity-steps/vas";
import NumberStep from "@/components/activity-library/activity-steps/number-response";
import TextStep from "@/components/activity-library/activity-steps/text-response";
import DateTimeStep from "@/components/activity-library/activity-steps/date-time";
import MultiChoiceStep from "@/components/activity-library/activity-steps/multi-choice";
import ImageChoiceStep from "@/components/activity-library/activity-steps/image";
import DropDownStep from "@/components/activity-library/activity-steps/dropdown";
import MeasurementsStep from "@/components/activity-library/activity-steps/measurements";
import LogStep from "@/components/activity-library/activity-steps/log";
import ValidatedEntryStep from "@/components/activity-library/activity-steps/validated-entry";
import IndexStep from "@/components/activity-library/activity-steps/index-step";
import GPSkinStep from "@/components/activity-library/activity-steps/gp-skin";
import ImageCaptureStep from "@/components/activity-library/activity-steps/image-capture";
import WongBakerStep from "@/components/activity-library/activity-steps/wong-baker";
import MedicationSelectorStep from "@/components/activity-library/activity-steps/medication-selector";
import AudioRecording from "@/components/activity-library/activity-steps/audio-recording";
import VideoRecording from "@/components/activity-library/activity-steps/video-recording";
import SurveyCompletion from "@/components/activity-library/activity-steps/custom-completion-screen";
import SkinAnalyser from "@/components/activity-library/activity-steps/skin-analyser";

export default {
  name: "ActivityStepEdit",
  data() {
    return {
      mode: "EDIT",
      commonProps: {},
      componentKey: Date.now(),
      editorOptionForHelp: {
        placeholder: "Enter guidance to assist the participant in responding to this activity step. This help text will be included in the IRB/EC automated documentation.",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      }
    };
  },
  created() {
    this.commonProps.editorOptionForQuestion = this.editorOptionForQuestion;
    this.commonProps.editorOptionForLabel = this.editorOptionForLabel;
    this.commonProps.editorOptionForValue = this.editorOptionForValue;
  },
  components: {
    BooleanStep,
    InstructionStep,
    NumberScaleStep,
    CustomScaleStep,
    VASStep,
    NumberStep,
    TextStep,
    DateTimeStep,
    MultiChoiceStep,
    ImageChoiceStep,
    DropDownStep,
    MeasurementsStep,
    LogStep,
    ValidatedEntryStep,
    IndexStep,
    GPSkinStep,
    WongBakerStep,
    MedicationSelectorStep,
    ImageCaptureStep,
    AudioRecording,
    VideoRecording,
    SurveyCompletion,
    SkinAnalyser
  },
  props: {
    question: {},
    activityDetails: {},
    editorOptionForQuestion: {},
    editorOptionForLabel: {},
    editorOptionForValue: {},
    onStepSave: {},
    audioSkippable: {
      type: Boolean,
      default: false
    },
    videoSkippable: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.componentKey = Date.now();
  },
  methods: {
    checkQuestionValidity() {
      const ref = this.$refs.activityStepEdit;

      if (ref) {
        if (typeof ref.checkQuestionValidity === "function") {
          return ref.checkQuestionValidity();
        }
      }
    }
  }
};
</script>

<style lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)
// This is all the styles for read only mode common to all step types inside activity-configurator-ste-edit-mode
.activity-configurator-step-edit-mode {
  body {
    color: #333;
  }

  .h2,
  h2 {
    font-size: 30px;
    margin: 20px 0 10px;
  }

  .h3,
  h3 {
    font-size: 24px;
    color: #333;
  }

  .h5,
  h5 {
    // opacity: 0.7;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    // color: #666769;
  }

  .h6,
  h6 {
    font-size: 12px;
    margin: 10px 0;
    color: #333;
  }

  .btn {
    font-size: 14px;
  }

  .col-xs-12 {
    width: 100%;
  }

  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12 {
    float: left;
    //flex: none;
    display: block;
  }

  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .col-xs-10 {
    width: 83.33333333%;
  }
  .img-border {
    border: 1px solid #000000;
  }
  .panel-default {
    border-color: #ddd;
  }

  .panel {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  }
  .modal-heading-text {
    width: 270px;
    padding-bottom: 20px;
  }

  .custom-image-pixels img {
    width: 100%;
    height: auto;
  }
  .add_edit_question_card {
    background-color: #f5f8fa;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #d3dfe4;
    padding: 16px;
  }

  .instruction {
    color: #959fa4;
    font-size: 12px;
    margin-top: 10px;
    ul {
      padding-left: 14px;
    }
  }
  .link-text {
    width: 175px;
    display: inline-block;
    margin-top: 5px;
    text-decoration: none;
    color: #007bff;
    cursor: pointer;
  }

  .upload_btn {
    width: 80px !important;
    height: 30px !important;
    position: relative;
    z-index: 99;
  }
  .mar-top15 {
    margin-top: 15px !important;
  }

  .row {
    display: block;

    &:after {
      content: "";
      clear: both;
      display: block;
    }
  }

  .color_959fa4 {
    color: #959fa4 !important;
  }

  .quill-score {
    width: 97%;
  }
  /deep/ .quill-editor {
    &.bg-white {
      position: relative;
      border-top: 1px solid #ccc;
      .ql-toolbar {
        &.ql-snow {
          border-bottom: none;
          border-top: none;
          padding: 4px;
          float: right;
          border-left: none;
          top: -40px;
          background-color: rgba(211, 223, 228, 0.5);
          position: absolute;
          right: 0;
          .ql-formats {
            margin-right: 0px;
            border: 1px solid #ccc;
            border-radius: 2px;
            margin-right: 10px;
            button {
              height: auto;
              padding: 4px 4px;
            }
            button:not(:last-child) {
              border-right: 1px solid #ccc;
            }
          }
          .ql-formats:last-child {
            border-right: 1px solid #ccc;
          }
          .ql-stroke {
            stroke: #ccc;
          }
          .ql-fill,
          .ql-snow .ql-stroke.ql-fill {
            fill: #ccc;
          }
        }
      }
      .ql-container {
        .ql-editor {
          height: auto;
          min-height: 0px;
        }
      }
    }
    &.instruction-screen {
      .ql-toolbar {
        &.ql-snow {
          top: -43px;
          .ql-formats {
            margin-top: 5px;
          }
        }
      }
      .ql-container {
        .ql-editor {
          min-height: 100px;
        }
      }
    }
  }

  .modal_header_color {
    color: #28406a;
  }
  .modal_desc {
    color: #535456;
  }
  .modal_custom {
    border-radius: 4px;
    padding: 16px;
  }
  .selectLibrary {
    border-radius: 3px;
    background-color: #ddd;
    padding: 5px;
    overflow: hidden;
    border: none;
    font-weight: 500;
    font-size: 14px;
    color: #555;
    width: 100%;
  }
  .selectLibrary:focus {
    outline: none;
  }
  .library_add_btn {
    max-width: 300px;
    margin: auto;
    height: 38px;
  }
  .paginate {
    color: grey;
    font-size: 14px;
    background-color: white;
    margin: 0px 8px 0px 0px;
    padding: 8px 5px 8px 5px;
    display: inline-block;
    cursor: pointer;
  }
  .active {
    color: #4c8ce4;
    font-size: 14px;
    font-weight: bolder;
  }
  .library_img_bg {
    display: -webkit-inline-box;
    background-color: #f5f8fa;
    border: solid 1px #d3dfe4;
    max-width: 200px;
    max-height: 80px;
    min-height: 70px;
    width: 98%;
    padding: 10px;
    text-align: -webkit-center;
    .logo {
      width: auto;
      margin: auto;
      height: 45px;
    }
    .icon {
      max-width: 50px;
      max-height: 50px;
      margin: auto;
    }
  }
  .selected_icon_logo_image {
    background-color: #4c8ce4;
    img {
      -webkit-filter: brightness(0) invert(1);
      filter: brightness(0) invert(1);
    }
  }

  @media (min-width: 768px) {
    .col-sm-1,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12 {
      float: left;
      display: block;
    }
    .col-sm-12 {
      width: 100%;
    }
    .col-sm-10 {
      width: 100%;
    }
    .col-sm-4 {
      width: 33.33333333%;
      max-width: 33.33333333%;
    }
    .col-md-2 {
      flex: none;
    }
  }

  @media (min-width: 992px) {
    .col-md-1,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-10,
    .col-md-11,
    .col-md-12 {
      float: left;
      flex: none;
    }
    .col-md-2 {
      width: 16.66666667%;
    }
    .col-md-10 {
      width: 83.33333333%;
    }
    .col-md-12 {
      width: 100%;
    }
    .col-lg-offset-4 {
      margin-left: 33.33333333%;
    }
  }

  @media (min-width: 1200px) {
    .col-lg-1,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12 {
      float: left;
      display: block;
    }
    .col-lg-2 {
      width: 16.66666667%;
    }
    .col-lg-10 {
      width: 82.33333333%;
    }
    .col-lg-11 {
      width: 91.66666667%;
    }
  }

  // END of style for quick fixes bootstrap after migration (before redesign should be removed)

  .add_edit_question_card {
    background-color: #f5f8fa;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #d3dfe4;
    padding: 16px;
    margin-bottom: 20px;
    display: block;
    .type_select {
      border-radius: 0 !important;
      width: 100%;
    }
    .options_section {
      background-color: #eaf0f4;
      border: solid 1px #e2e7ea;
      display: inline-block;
      width: 100%;
      border-radius: 2px;
      padding: 5px;
      margin: 10px 0 0;
    }
    .limit_text_input {
      position: absolute;
      top: -3px;
      left: 135px;
      width: 127px;
      height: 28px;
      margin-left: 12px;
    }
    .answer_label_text_input {
      width: 127px;
    }
    .min_value_input {
      width: 50px;
    }
    .max_value_input {
      left: 210px;
      width: 50px;
    }
    .min_max_to_text {
      position: absolute;
      top: 0px;
      left: 204px;
    }
    .add_another_answer {
      font-size: 12px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      a {
        color: #4c8ce4;
        cursor: pointer;
      }
    }
    label {
      font-weight: normal;
      margin-bottom: 10px;
    }
    .multi_choice_type {
      padding-top: 5px;
    }
    .scale_choice_type {
      padding-top: 5px;
      .radio-style {
        margin: 0;
      }
    }
    .text_choice_type {
      padding-top: 5px;
    }
    .number_choice_type {
      padding-top: 5px;
    }
    .date_time_type {
      padding-top: 5px;
      label {
        width: auto;
        margin-right: 15px;
      }
    }
    .save_btn {
      width: 100px;
    }
    .branch_section {
      position: relative;
      top: -20px;
    }
    .form-control,
    .input-text {
      border-radius: 2px !important;
    }
    .file_container [type="file"] {
      cursor: inherit;
      display: block;
      font-size: 20px;
      filter: alpha(opacity=0);
      width: 80px;
      height: 31px;
      max-height: 50px;
      max-width: 300px;
      opacity: 0;
      position: absolute;
      right: 0;
      text-align: right;
      top: 0px;
      left: 0px;
      z-index: 100;
    }
    .file_container [type="file"].language-img-file {
      cursor: inherit;
      display: block;
      filter: alpha(opacity=0);
      opacity: 0;
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
      height: auto;
      border: 1px solid red;
      font-size: initial;
    }
    .file_container {
      padding: 0px 10px 0 0;
      color: grey;
    }
    .file_container [type="file"] {
      cursor: pointer;
    }
    .file_container_text {
      background-color: #d3dfe4;
      padding: 5px;
      width: 100%;
      display: block;
      border-radius: 4px;
      text-align: center;
      color: #959fa4;
    }
    .error-style {
      font-size: 12px;
      color: #ff4848;
      padding-bottom: 5px;
      padding-left: 0;
    }
    .text-style {
      padding: 9px 0px 0 0;
      font-size: 12px;
      color: #959fa4;
    }
    .img_size {
      width: 100%;
      height: 100%;
      border: 1px solid #d3dfe4;
    }
    @media (max-width: 575px) {
      .col-sm-12 {
        padding: 0px;
      }
      .branch_section {
        padding-top: 25px;
      }
    }
    @media (min-width: 576px) and (max-width: 767px) {
      .col-sm-12 {
        padding: 0px;
      }
      .branch_section {
        padding-top: 25px;
      }
      .text-style {
        padding: 0 0 20px 0;
      }
    }
    @media (min-width: 768px) and (max-width: 991px) {
      .col-sm-12 {
        padding: 0px;
      }
      .branch_section {
        padding-top: 25px;
      }
      .text-style {
        padding: 0 0 20px 0;
      }
    }
    @media (min-width: 992px) and (max-width: 1199px) {
      .branch_section {
        padding-right: 0;
      }
    }
    @media (min-width: 1200px) {
      .branch_section {
        padding-right: 0;
      }
      .gpskin-example-link {
        margin-left: -35px;
      }
    }
  }

  //for instruction type
  .file_container1 [type="file"] {
    cursor: pointer;
    display: block;
    font-size: 20px;
    filter: alpha(opacity=0);
    width: 100px;
    height: 40px;
    max-height: 50px;
    max-width: 200px;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
    left: 0;
  }
  .file_container1 {
    margin-top: 5px;
    color: #555;
  }
  .file_container1 [type="file"] {
    cursor: pointer;
  }
  .file_container_text1 {
    background-color: #ddd;
    padding: 5px;
    width: 100%;
    display: block;
    border-radius: 4px;
    text-align: center;
  }
  .info-circle {
    padding-left: 15px;
  }

  .info-circle-div {
    width: 280px;
    height: 80px;
    background-color: #ffffff;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #666669;
    padding: 13px 16px 19px 13px;
    position: absolute;
    border-radius: 3px;
    margin-left: 510px;
    margin-top: -35px;
    box-shadow: 1px 1px #d3deef;
    z-index: 100;
  }

  .color_red {
    padding-top: 0px;

    img {
      vertical-align: middle;
      /* border-style: none; */
      padding: 8px;
      border: 1px solid #d3dfe4;
      background: #d3dfe4;
      opacity: 0.6;
      border-radius: 3px;
    }
  }

  .col-sm-10 {
    max-width: 100%;
  }

  .form-group {
    margin-bottom: 10px;
  }

  .form-control::placeholder {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #c5d1d6;
  }

  .btn-success {
    height: 36px;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  /*checkbox data*/
  input[type="checkbox"] + span {
    display: block;
  }

  input[type="checkbox"] {
    display: none;
    height: 26px;
    width: 26px;
  }
  input[type="checkbox"] + span:before {
    content: "\2714";
    border: 0.1em solid #d3dfe4;
    border-radius: 3px;
    width: 26px;
    display: inline-block;
    height: 26px;
    padding-left: 5px;
    margin-right: 7px;
    vertical-align: middle;
    color: transparent;
    background-color: #fff;
  }

  input[type="checkbox"]:checked + span:before {
    background-color: #4c8ce4;
    border: 0.1em solid #4c8ce4;
    color: #fff;
    font-size: 16px;
    padding-bottom: 5px;
  }

  .example {
    color: #4c8ce4;
    cursor: pointer;
  }

  .cancelImage {
    color: #959fa4;
    float: right;
    font-size: 18px;
    cursor: pointer;
  }

  .scale-info {
    opacity: 0.7;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #666669;
  }

  .scale-info-div {
    margin-left: 105px !important;
    bottom: 104px !important;
    width: 360px !important;
  }

  .score-info-div {
    margin-left: 190px !important;
    width: 250px !important;
    height: 100px !important;
  }
  .length-info-div {
    margin-left: 90px !important;
    width: 250px !important;
    height: 75px !important;
    margin-top: 42px !important;
    z-index: 1000;
  }
  .restrain-info-div {
    margin-left: 150px !important;
    width: 200px !important;
    z-index: 1000;
  }

  .gp-help-text {
    font-size: 12px;
    color: #666669;
    opacity: 0.67;
  }

  .img-placeholder {
    background: #fff;
    border: 2px dashed #d3dee3;
    display: block;
    padding: 20px 5px;
    color: 666669;
    opacity: 0.7;
    font-size: 12px;
    border-radius: 3px;
  }
  .use-english-img {
    .info-circle-div {
      margin-left: 400px;
    }
  }
  .soft_max.max_value_input {
    left: 238px !important;
  }
  span.soft_min_to.min_max_to_text {
    left: 230px !important;
  }
  .soft_min.min_value_input {
    left: 160px !important;
  }
  .unit_input {
    left: 75px !important;
  }
  .select-completedby {
    width: 200px;
  }
  .image_score_text,
  .image_score_input {
    left: 0px;
  }

  .score_text {
    position: absolute;
    top: 0px;
    left: 10px;
  }
  .score_input {
    position: absolute;
    left: 9px;
    top: 30px;
    height: 40px;
    width: 110px;
  }
  .inner-card-value {
    font-size: 14px !important;
    color: #4a4a4a;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    width: 100%;
  }

  .setting-btn-text {
    position: relative;
    right: 5px;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #b0bac9;
  }

  .switch-option {
    float: left;
    width: 100%;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 38px;
    height: 23px;
    float: left;
    margin-right: 10px;
  }

  .switch input {
    display: none;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid #ccc;
  }

  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 1px;
    background-color: #ccc;
  }
  input:checked + .slider {
    border: 2px solid #48bf7a;
  }
  input:checked + .slider:before {
    content: "";
    background-color: #48bf7a;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }
  input:checked + .slider:before {
    /*content: '✓';*/
    position: absolute;
    color: #2ecc71;
    text-align: center;
    font-size: 20px;
    -webkit-transform: translateX(14px);
    -ms-transform: translateX(14px);
    transform: translateX(14px);
  }

  h5.question,
  h5.answer {
    top: 30px;
    position: relative;
  }
  .scale-right {
    top: 30px;
  }
  .section_weight input {
    background-color: #eee;
    border-radius: 3px;
    color: #000;
    line-height: 26px;
    border: none;
    padding: 0 10px;
    text-align: right;
    width: 100%;
    height: 32px;
  }
  .group-scoring__container-edit {
    padding: 2px;
    border-radius: 3px;
    border: solid 1px #b0bac9;
    background-color: #b0bac9;
  }
  input.group-scoring__name-input {
    width: 100%;
    height: 33px;
    border-radius: 3px;
    border: solid 1px #b0bac9;
    background-color: #ffffff;
  }
  .save_sec_btn {
    height: 33px;
    border-radius: 5px;
    padding: 0 15px;
    color: #fff;
    border: none;
    background-color: #4c8ce4;
    width: 79%;
    float: left;
  }
  .group-scoring__weights-section {
    line-height: 30px;
  }
  button.int-pm-btn {
    width: 32px;
  }
  .int-pm .int-pm-value {
    background-color: #fff !important;
    width: 45px !important;
    padding: 10px 15px !important;
  }
  .score_cls {
    margin-left: -1.3%;
  }

  .score_cls_vas {
    margin-left: 4%;
  }

  h5.operator_text {
    opacity: 1;
  }
  .start-date input {
    height: 40px;
    border-radius: 3px !important;
    border: solid 2px #d3dfe4 !important;
    font-size: 14px;
  }

  .set_score {
    width: 200px;
    display: block;
  }

  .set_score .score_text {
    clear: both;
    float: left;
    position: unset;
  }

  .width-50 {
    width: 50%;
    float: left;
  }
  .delete-section {
    line-height: 32px;
    text-align: left;
    position: relative;
    right: 10px;
  }
}
</style>
